import React from "react";

const VARIANTS = {
  invited: {
    bg: "bg-purple-50",
    text: "text-purple-700",
    ring: "ring-purple-300",
  },
  active: {
    bg: "bg-green-50",
    text: "text-green-700",
    ring: "ring-green-300",
  },
  inactive: {
    bg: "bg-pink-50",
    text: "text-pink-700",
    ring: "ring-pink-300",
  },
  registered: {
    bg: "bg-orange-50",
    text: "text-orange-700",
    ring: "ring-orange-300",
  },
  default: {
    bg: "bg-gray-50",
    text: "text-gray-500",
    ring: "ring-gray-300",
  },
};

export function Pill({
  label,
  variant = "default",
  size = "sm", // sm | md
  className = "",
}) {
  const v = VARIANTS[variant] ?? VARIANTS.default;

  const SIZES = {
    sm: "px-2 py-1 text-xs rounded-md",
    md: "px-4 py-1.5 text-sm rounded-md",
  };

  return (
    <span
      className={[
        "inline-flex items-center font-normal ring-1 ring-inset whitespace-nowrap",
        v.bg,
        v.text,
        v.ring,
        SIZES[size],
        className,
      ].join(" ")}
    >
      {label}
    </span>
  );
}